import { render } from "./Home.vue?vue&type=template&id=9ca27438&scoped=true&bindings={\"goToDetail\":\"setup\",\"tips\":\"setup\"}"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=9ca27438&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-9ca27438"

export default script